import { PAGES, QUERY_PARAM_KEYS } from './constants.js';

/**
 * Replaces the teachers link href with the device-aware teachers URL.
 * @param {{ id?: string, href: string }[]} links The array of links like moreAbcmouseLinks
 * @param {string | null | undefined} deviceId The device id
 * @returns {{ id?: string, href: string }[]}
 */
export function withTeachersExternalUrl(links, deviceId) {
	const teachersHref = buildTeachersExternalUrl(deviceId);
	return links.map((link) => (link.id === 'teachers' ? { ...link, href: teachersHref } : link));
}

/**
 * Prefer an explicit `to` query param as-is; otherwise return `fallbackPath`,
 * optionally preserving the current URL's query params via `withPreservedQueryParams`.
 * @param {URL} url - Current page URL
 * @param {string} fallbackPath - Path used when `to` is absent
 * @param {boolean} [preserveQueryParams] - Whether to append current query params to the fallback
 * @returns {string}
 */
export function getGotoOrFallbackPath(url, fallbackPath, preserveQueryParams = true) {
	const toParam = url.searchParams.get(QUERY_PARAM_KEYS.GOTO);
	if (toParam) {
		return decodeURIComponent(toParam);
	}
	return preserveQueryParams ? withPreservedQueryParams(url, fallbackPath) : fallbackPath;
}

/**
 * Appends query params from `url` onto `path` (excluding `to`).
 * @param {URL} url - Source URL whose query params should be preserved
 * @param {string} path - Destination path (may already include a query string)
 * @returns {string}
 */
export function withPreservedQueryParams(url, path) {
	const params = new URLSearchParams(url.searchParams);
	params.delete(QUERY_PARAM_KEYS.GOTO);
	const qs = params.toString();
	if (!qs) return path;
	return `${path}${path.includes('?') ? '&' : '?'}${qs}`;
}

/**
 * Builds the teachers.abcmouse.com handoff URL. Appends `device_id` only when a
 * non-empty id is provided.
 * @param {string | null | undefined} deviceId The device id
 * @returns {string}
 */
export function buildTeachersExternalUrl(deviceId) {
	const url = new URL(PAGES.EXTERNAL.TEACHERS);
	if (deviceId) {
		url.searchParams.set('device_id', deviceId);
	}
	return url.toString();
}
